'use client';
import { forwardRef, cloneElement } from 'react';
import { useMergedRefs } from '@s7/hooks';
import { isElement } from '@s7/react-utils';
import { useProps, clsx } from '@s7/styles';
import { DesignSystemError } from '@s7/system';
import { usePopoverContext } from '../Popover.context.js';
import { POPOVER_ERRORS_CHILDREN } from '../Popover.errors.js';
import { IDENT_POPOVER_TARGET, targetDefaultProps } from './PopoverTarget.contract.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const PopoverTarget = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { opened, getDropdownId, getTargetId, reference, targetProps, withRoles, controlled, onToggle, preset } = usePopoverContext();
    const _useProps = useProps(IDENT_POPOVER_TARGET, _extends({
        preset
    }, props), targetDefaultProps), [{ children, refProp, popupType }] = _useProps, others = _object_without_properties_loose(_useProps[0], [
        "children",
        "refProp",
        "popupType"
    ]);
    if (!isElement(children)) {
        throw new DesignSystemError('ui', POPOVER_ERRORS_CHILDREN);
    }
    const forwardedProps = others;
    const validChildren = children;
    const definedRefProp = refProp;
    const targetRef = useMergedRefs(reference, validChildren.ref, ref);
    const accessibleProps = withRoles ? {
        'aria-haspopup': popupType,
        'aria-expanded': opened,
        'aria-controls': getDropdownId(),
        id: getTargetId()
    } : {};
    return /*#__PURE__*/ cloneElement(validChildren, _extends({}, forwardedProps, accessibleProps, targetProps, {
        className: clsx(targetProps.className, forwardedProps.className, validChildren.props.className),
        [definedRefProp]: targetRef
    }, !controlled ? {
        onClick: onToggle
    } : null));
});
PopoverTarget.displayName = 'Popover.Target';

export { PopoverTarget };
//# sourceMappingURL=PopoverTarget.js.map
